import { IJsonQuery } from '@cian/api-models/common/json_query';

import { TReduxActions } from '../../../types/redux';
import { FILTERS_SET_BEDROOMS_COUNT_TYPE } from '../../../constants/action_types';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function setBedroomsCountReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_BEDROOMS_COUNT_TYPE:
      return new JsonQuery(jsonQuery).setBedroomsCount(action.bedroomsCount || undefined, undefined).getSerializable();
  }

  return jsonQuery;
}
